function AssociativeArray() { };

try {
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (needle) {
            for (var i = 0; i < this.length; i++) {
                if (this[i] === needle) {
                    return i;
                }
            }
            return -1;
        };
    }

}
catch (defPropException) { };

try {
    Object.defineProperty(AssociativeArray.prototype, "length", {
        get: function () {
            var count = 0;
            for (var key in this) {
                if (this.hasOwnProperty(key))
                    count++;
            }
            return count;
        }
    });
} catch (defPropException) { };

export default AssociativeArray;